import React, {Component} from 'react';
import {DOMAIN, ENVIRONMENT} from '../../../shared/constants/URLs';
import { projectConfig } from '../../../shared/project-info/projectConfig';

export default class ApiInfo extends Component {
  render() {
    return (
      <>
        {window.location.host !== projectConfig.prodHost && (
          <div>
            <p>Current API Server: {DOMAIN}</p>
            <p>Environment: {ENVIRONMENT}</p>
            <p>Note: This info is not rendered on production.</p>
          </div>
        )}
      </>
    );
  }
}
